import { render } from "./ChecklistReception.vue?vue&type=template&id=07b7f56c"
import script from "./ChecklistReception.vue?vue&type=script&lang=js"
export * from "./ChecklistReception.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__